import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AssetCheckResultCard } from '@/components/assetCheck/AssetCheckResultCard'
import { getAssetCheck } from '@/lib/assetCheckApi'

export function AssetCheckDetailPage() {
  const { id } = useParams<{ id: string }>()
  const checkId = Number(id)

  const query = useQuery({
    queryKey: ['asset-check', 'detail', checkId],
    queryFn: () => getAssetCheck(checkId),
    enabled: !Number.isNaN(checkId),
  })

  return (
    <AppShell>
      <article className="fade-in max-w-4xl space-y-4" data-testid="asset-check-detail-page">
        <div>
          <Link to="/asset-check" className="text-sm text-bernstein hover:underline">
            ← Zurück zur Übersicht
          </Link>
        </div>
        {query.isLoading && <div className="text-sm text-slate-500">Lade …</div>}
        {query.isError && (
          <div className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-900">
            Check nicht gefunden.
          </div>
        )}
        {query.data && (
          <>
            {query.data.emergency_mode_active && (
              <div role="alert" className="mb-6 border border-loss/40 bg-loss/5 px-4 py-3">
                <p className="tracked-caps text-[10px] text-loss">Emergency-Mode aktiv</p>
                <p className="mt-1 text-sm text-ink">🚨 48 h Bedenkzeit vor jedem Kauf empfohlen</p>
                <p className="mt-1 font-mono text-xs text-muted">
                  Verdict bleibt unverändert — der Hinweis ist eine zusätzliche Erinnerung während
                  des aktiven Emergency-Mode.
                </p>
              </div>
            )}
            <AssetCheckResultCard check={query.data} />
          </>
        )}
      </article>
    </AppShell>
  )
}
